import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Box, Container, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import Logo from 'src/components/Logo';
const useStyles = makeStyles((theme) => ({
    root: {
        justifyContent: 'center',
        backgroundColor: (theme.palette.background as any).dark,
        display: 'flex',
        height: '100%',
        minHeight: '100%',
        flexDirection: 'column',
        paddingBottom: 80,
        paddingTop: 80
    },
    backButton: {
        marginLeft: theme.spacing(2)
    },
}));
type Props = {
    title?: string;
    children?: any;
};
function BaseAuthPage(props: Props) {
    const classes = useStyles();
    const { title, children, } = props;
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; className: string; titl... Remove this comment to see the full error message
    return (<Page className={classes.root} title={title}>
      <Container maxWidth="sm">
        <Box mb={5} display="flex" alignItems="center">
          <RouterLink to="/">
            <Logo />
          </RouterLink>
          <Button component={RouterLink} to="/" className={classes.backButton}>
            Back to home
          </Button>
        </Box>
        {children}
      </Container>
    </Page>);
}
export default BaseAuthPage;
